const alertNotification = {
  deposit: 'depositNotificationSound',
  withdraw: 'withdrawNotificationSound'
}

export default alertNotification